import React from 'react';
import { Navigate, useLocation, Outlet } from 'react-router-dom';
import { useAuthentication } from '../context/Authentication';

type PrivateRouteProps = {
  requirePairingAccess?: boolean;
  redirectTo?: string;
};

const PrivateRoute: React.FunctionComponent<PrivateRouteProps> = ({
  requirePairingAccess = false,
  redirectTo = '/about',
}) => {
  const { isAuthenticated, canAddPatients } = useAuthentication();
  const location = useLocation();

  if (!isAuthenticated) {
    return (
      <Navigate
        to={{
          pathname: '/login',
        }}
        state={{ referrer: location }}
        replace
      />
    );
  }

  if (requirePairingAccess && !canAddPatients) {
    return <Navigate to={redirectTo} state={{ referrer: location }} replace />;
  }

  return <Outlet />;
};
export default PrivateRoute;
